import { IRememberMe, ISharedData } from './state-interfaces';
import * as actions from './actionTypes';
import { Site } from 'src/app/site-management/site-management-interfaces';
import { Building } from 'src/app/building-managment/building-management-interfaces';
import { Floor } from 'src/app/floor-management/floor-management-interface';
import { Brand, Language } from '../models/types';
import {
  IUser,
  SharedUser,
} from 'src/app/user-management/user-management-interfaces';
import { IDevice } from 'src/app/building-managment/building-unit-details/add-lock/lock-management-interfaces';
import { Activities } from 'src/app/shared-layout/Components/activity/activity.interface';
import {
  ActiveIssues,
  UserCards,
} from 'src/app/shared-layout/Components/activity/user-card.interface';
import { Action } from 'redux';

export const logoutAction = () => {
  return { type: actions.LOGOUT };
};

export const updateUserBrand = (brand: Brand) => {
  return { type: actions.UPDATE_USER_BRAND, brand: brand };
};

export const updateUserLanguage = (preferredLanguage: Language) => {
  return { type: actions.CHANGE_LANGUAGE, preferredLanguage: preferredLanguage };
};

export const updateUser = (user: IUser) => {
  return { type: actions.UPDATE_USER, user: user };
};

export const updateUserActivities = (userActivities: any) => ({
  type: actions.UPDATE_USER_ACTIVITIES,
  userActivities,
});

export const clearUserActivities = () => ({
  type: actions.CLEAR_USER_ACTIVITIES,
});

export const prependUserActivities = (userActivities: Activities) => {
  return {
    type: actions.PREPEND_USER_ACTIVITIES,
    userActivities: userActivities,
  };
};

export const updateRememberMe = (rememberMe: IRememberMe) => {
  return { type: actions.UPDATE_REMEMBER_ME, rememberMe: rememberMe };
};

export const updateUserLoggedIn = (isLoggedIn: boolean) => {
  return { type: actions.UPDATE_IS_LOGGED_IN, isLoggedIn };
};

export const updateUserObject = (userObject: Object) => {
  return { type: actions.UPDATE_USER_OBJECT, userObject: userObject };
};

export const updateUsersList = (usersList: IUser[]) => {
  return { type: actions.UPDATE_USERS_LIST, usersList: usersList };
};

export const updateUsersTabList = (usersTabList: IUser[]) => {
  return { type: actions.UPDATE_USERS_TAB_LIST, usersTabList: usersTabList };
};

export const prependUsersList = (usersList: IUser[]) => {
  return {
    type: actions.PREPEND_USER_LIST,
    usersList: usersList,
  };
};
export const prependUsersTabList = (usersTabList: IUser[]) => {
  return {
    type: actions.PREPEND_USER_TAB_LIST,
    usersTabList: usersTabList,
  };
};
export const updateDashboardUsersList = (dashboardUsersList: SharedUser) => {
  return {
    type: actions.UPDATE_DASHBOARD_USERS_LIST,
    dashboardUsersList: dashboardUsersList,
  };
};

export const updateUnitOrAccessPointUsersList = (
  unitOrAccessPointUserList: IUser[]
) => {
  return {
    type: actions.UPDATE_UNIT_AND_ACCESSPOINT_USERS_LIST,
    unitOrAccessPointUserList,
  };
};

export const updateShowHeader = (showHeader: boolean) => {
  return { type: actions.UPDATE_HEADER_STATE, showHeader: showHeader };
};

export const updateSharedData = (sharedData: ISharedData) => {
  return { type: actions.UPDATE_SHARED_DATA, sharedData: sharedData };
};

export const updateSites = (sites: Site) => {
  return { type: actions.UPDATE_SITES, sites: sites };
};

export const updateBuildings = (buildings: Building) => {
  return { type: actions.UPDATE_BUILDINGS, buildings: buildings };
};

export const updateFloors = (floors: Floor) => {
  return { type: actions.UPDATE_FLOORS, floors: floors };
};

export const updateDeviceList = (deviceList: IDevice[]) => {
  return { type: actions.UPDATE_DEVICE_LIST, deviceList: deviceList };
};
export const updatePartnerDeviceList = (partnerDeviceList: IDevice[]) => {
  return {
    type: actions.UPDATE_PARTNER_DEVICE_LIST,
    partnerDeviceList: partnerDeviceList,
  };
};

export const updateAccessPointAcvities = (
  accessPointActivities: Activities
) => {
  return {
    type: actions.UPDATE_ACCESSPOINT_ACTIVITIES,
    accessPointActivities: accessPointActivities,
  };
};

export const updateBuildingActivities = (buildingActivities: any) => ({
  type: actions.UPDATE_BUILDING_ACTIVITIES,
  buildingActivities,
});

export const clearBuildingActivities = () => ({
  type: actions.CLEAR_BUILDING_ACTIVITIES,
});

export const prependBuildingActivities = (buildingActivities: Activities) => {
  return {
    type: actions.PREPEND_BUILDING_ACTIVITIES,
    buildingActivities: buildingActivities,
  };
};
export const prependAccessPointActivities = (
  accessPointActivities: Activities
) => {
  return {
    type: actions.PREPEND_ACCESSPOINT_ACTIVITIES,
    accessPointActivities: accessPointActivities,
  };
};
export const updateUnitAcvities = (unitActivities: Activities) => {
  return {
    type: actions.UPDATE_UNIT_ACTIVITIES,
    unitActivities: unitActivities,
  };
};
export const updateUnitFilterAcvities = (unitActivities: Activities) => {
  return {
    type: actions.UPDATE_UNIT_FILTER_ACTIVITIES,
    unitActivities: unitActivities,
  };
};
export const prependUnitActivities = (unitActivities: Activities) => {
  return {
    type: actions.PREPEND_UNIT_ACTIVITIES,
    unitActivities: unitActivities,
  };
};
export const prependUnitFilterAcvities = (unitActivities: Activities) => {
  return {
    type: actions.PREPEND_UNIT_FILTER_ACTIVITIES,
    unitActivities: unitActivities,
  };
};
export const updateDashboard = (dashboardActivity: UserCards) => {
  return {
    type: actions.UPDATE_DASHBOARD_ACTIVITIES,
    dashboardActivities: dashboardActivity,
  };
};

export const updateActiveIssues = (activeIssuesActivity: ActiveIssues) => {
  return {
    type: actions.UPDATE_ACTIVE_ISSUES,
    activeIssuesActivity: activeIssuesActivity,
  };
};
